import { CALL_API, CONTENT_TYPE } from 'middlewares/api';
import { url } from 'configs';
import {
  downloadFile,
} from 'containers/App/screens/Tube/utils/downloadFile';
const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_GETFROMMEDATALIST_REQUEST = 'tube/assignmenttask/received/FETCH_GETFROMMEDATALIST_REQUEST';
const FETCH_GETFROMMEDATALIST_SUCCESS = 'tube/assignmenttask/received/FETCH_GETFROMMEDATALIST_SUCCESS';
const FETCH_GETFROMMEDATALIST_ERROR = 'tube/assignmenttask/received/FETCH_GETFROMMEDATALIST_ERROR';

const FETCH_GETFROMMEDATA_REQUEST = 'tube/assignmenttask/received/FETCH_GETFROMMEDATA_REQUEST';
const FETCH_GETFROMMEDATA_SUCCESS = 'tube/assignmenttask/received/FETCH_GETFROMMEDATA_SUCCESS';
const FETCH_GETFROMMEDATA_ERROR = 'tube/assignmenttask/received/FETCH_GETFROMMEDATA_ERROR';

const POST_DOWNLOADEXCEL_REQUEST = 'tube/assignmenttask/received/POST_DOWNLOADEXCEL_REQUEST';
const POST_DOWNLOADEXCEL_SUCCESS = 'tube/assignmenttask/received/POST_DOWNLOADEXCEL_SUCCESS';
const POST_DOWNLOADEXCEL_ERROR = 'tube/assignmenttask/received/POST_DOWNLOADEXCEL_ERROR';

const POST_MESSAGE_REQUEST = 'tube/assignmenttask/received/POST_MESSAGE_REQUEST';
const POST_MESSAGE_SUCCESS = 'tube/assignmenttask/received/POST_MESSAGE_SUCCESS';
const POST_MESSAGE_ERROR = 'tube/assignmenttask/received/POST_MESSAGE_ERROR';

const PUT_GETFROMMESTATUS_REQUEST = 'tube/assignmenttask/received/PUT_GETFROMMESTATUS_REQUEST';
const PUT_GETFROMMESTATUS_SUCCESS = 'tube/assignmenttask/received/PUT_GETFROMMESTATUS_SUCCESS';
const PUT_GETFROMMESTATUS_ERROR = 'tube/assignmenttask/received/PUT_GETFROMMESTATUS_ERROR';

const UPLOAD_MESSAGE_FILE_REQUEST = 'tube/assignmenttask/received/UPLOAD_MESSAGE_FILE_REQUEST';
const UPLOAD_MESSAGE_FILE_SUCCESS = 'tube/assignmenttask/received/UPLOAD_MESSAGE_FILE_SUCCESS';
const UPLOAD_MESSAGE_FILE_ERROR = 'tube/assignmenttask/received/UPLOAD_MESSAGE_FILE_ERROR';

const POST_NEWMESSAGE_REQUEST = 'tube/assignmenttask/received/POST_NEWMESSAGE_REQUEST';
const POST_NEWMESSAGE_SUCCESS = 'tube/assignmenttask/received/POST_NEWMESSAGE_SUCCESS';
const POST_NEWMESSAGE_ERROR = 'tube/assignmenttask/received/POST_NEWMESSAGE_ERROR';

const UPLOAD_MAINMESSAGE_FILE_REQUEST = 'tube/assignmenttask/received/UPLOAD_MAINMESSAGE_FILE_REQUEST';
const UPLOAD_MAINMESSAGE_FILE_SUCCESS = 'tube/assignmenttask/received/UPLOAD_MAINMESSAGE_FILE_SUCCESS';
const UPLOAD_MAINMESSAGE_FILE_ERROR = 'tube/assignmenttask/received/UPLOAD_MAINMESSAGE_FILE_ERROR';

export default function reducer(state = {
  getfrommeList: {
    isLoadingList: false,
    data: [],
    meta: {},
  },
  getfromme: {
    isLoadingData: false,
    data: {},
    meta: {},
  },
}, action) {
  switch (action.type) {
    case FETCH_GETFROMMEDATALIST_REQUEST:
      return Object.assign({}, state, {
        getfrommeList: {
          isLoadingList: true,
        },
      });
    case FETCH_GETFROMMEDATALIST_SUCCESS:
      return Object.assign({}, state, {
        getfrommeList: {
          isLoadingList: false,
          data: action.response.data,
          meta: action.response.meta,
        },
      });
    case FETCH_GETFROMMEDATA_REQUEST:
      return Object.assign({}, state, {
        getfromme: {
          isLoadingData: true,
        },
      });
    case FETCH_GETFROMMEDATA_SUCCESS:
      return Object.assign({}, state, {
        getfromme: {
          isLoadingData: false,
          data: action.response.data,
          meta: action.response.meta,
        },
      });
    default:
      return state;
  }
}

// 列表
export function fetchGetFromMeDataList(pageNumber) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'assignment/GetFromMe?PageNumber=' + pageNumber,
      method: 'GET',
      types: [
        FETCH_GETFROMMEDATALIST_REQUEST,
        FETCH_GETFROMMEDATALIST_SUCCESS,
        FETCH_GETFROMMEDATALIST_ERROR,
      ],
    },
  };
}

// 單筆
export function fetchGetFromMeData(AssignmentId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'assignment/GetFromMe/' + AssignmentId,
      method: 'GET',
      types: [
        FETCH_GETFROMMEDATA_REQUEST,
        FETCH_GETFROMMEDATA_SUCCESS,
        FETCH_GETFROMMEDATA_ERROR,
      ],
    },
  };
}

// 下載報表
export function postDownloadExcel(AssignmentIdArray) {
  const downloadUrl = NEWTUBE_API_SERVER + 'Assignment/DownloadExcel';
  const types = [
    POST_DOWNLOADEXCEL_REQUEST,
    POST_DOWNLOADEXCEL_SUCCESS,
    POST_DOWNLOADEXCEL_ERROR,
  ];
  const params = AssignmentIdArray;
  const method = 'POST';
  return downloadFile(downloadUrl, types, params, method);
}

// 回覆訊息
export function postMessage(AssignmentId, message) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Assignment/' + AssignmentId + '/Message',
      method: 'POST',
      types: [
        POST_MESSAGE_REQUEST,
        POST_MESSAGE_SUCCESS,
        POST_MESSAGE_ERROR,
      ],
      params: {
        Message: message,
      },
    },
  };
}

// 更改狀態
export function putGetFromMeStatus(assignmentId, status) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Assignment/GetFromMe/' + assignmentId + '/' + status,
      method: 'PUT',
      types: [
        PUT_GETFROMMESTATUS_REQUEST,
        PUT_GETFROMMESTATUS_SUCCESS,
        PUT_GETFROMMESTATUS_ERROR,
      ],
    },
  };
}

// 下載附件
export function downloadAttachment(apiUrl) {
  let downloadUrl = apiUrl.split('api/')[1];
  downloadUrl = NEWTUBE_API_SERVER + downloadUrl;
  return downloadUrl;
}

// 上傳訊息附件
export function uploadMessageFile(AssignmentId, messageId, formData) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Assignment/' + AssignmentId + '/Message/' + messageId + '/Attachment',
      method: 'POST',
      types: [
        UPLOAD_MESSAGE_FILE_REQUEST,
        UPLOAD_MESSAGE_FILE_SUCCESS,
        UPLOAD_MESSAGE_FILE_ERROR,
      ],
      contentType: CONTENT_TYPE.FORM,
      params: formData,
    },
  };
}

// 新增訊息
export function postNewMessage(data) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Assignment/GetFromMe',
      method: 'POST',
      types: [
        POST_NEWMESSAGE_REQUEST,
        POST_NEWMESSAGE_SUCCESS,
        POST_NEWMESSAGE_ERROR,
      ],
      params: data,
    },
  };
}

// 上傳主體附件
export function uploadMainMessageFile(AssignmentId, formData) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Assignment/GetFromMe/' + AssignmentId + '/Attachment',
      method: 'POST',
      types: [
        UPLOAD_MAINMESSAGE_FILE_REQUEST,
        UPLOAD_MAINMESSAGE_FILE_SUCCESS,
        UPLOAD_MAINMESSAGE_FILE_ERROR,
      ],
      contentType: CONTENT_TYPE.FORM,
      params: formData,
    },
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/AssignmentTask/screens/Sended/reducers/index.js
 **/